import { Colors, Services } from '@sigma-frontend-libs/commons'

import { buttonModes, components, getLocaleDateString, getLocaleTimeString, sizes } from '@/utils'

import button from '@/components/button'
import infoCard from '@/components/info/card'
import SingleLink from '@/components/misc/SingleLink'
import tag from '@/components/tag'

function renderChannel(h) {
  return h(
    tag,
    {
      props: {
        label: this.getTranslate(`${Services.sendings}.types.${this.data.channel}`),
        size: sizes.small,
        color: Colors[this.data.channel]
      }
    }
  )
}
function renderIsRead(h) {
  let color = Colors.grey
  if (this.data.isRead) {
    color = Colors.success
  }

  return h(
    tag,
    {
      props: {
        label: this.getTranslate(`${Services.notifications}.isRead.${this.data.isRead}`),
        size: sizes.small,
        color
      }
    }
  )
}
function renderTags(h) {
  return h(
    'div',
    {
      class: `${Services.notifications}-dialog__tags`
    },
    [
      renderChannel.call(this, h),
      renderIsRead.call(this, h)
    ]
  )
}
function renderId(h) {
  return h(
    infoCard,
    {
      props: {
        label: this.getTranslate('commons.labels.id'),
        value: this.data.id
      }
    }
  )
}
function renderText(h) {
  return h(
    infoCard,
    {
      props: {
        label: this.getTranslate(`${Services.notifications}.labels.text`),
        value: this.data.text
      }
    }
  )
}
function renderTargetUser(h) {
  return h(
    SingleLink,
    {
      props: {
        value: this.data.targetUserId
      }
    }
  )
}
function renderCreatedAt(h) {
  return h(
    'div',
    {
      class: `${Services.notifications}-dialog__details-date`
    },
    [ [ getLocaleDateString(this.data.createdAt), getLocaleTimeString(this.data.createdAt) ].join(' ') ]
  )
}
function renderDetails(h) {
  return h(
    'div',
    {
      class: `${Services.notifications}-dialog__details`
    },
    [
      renderTargetUser.call(this, h),
      renderCreatedAt.call(this, h)
    ]
  )
}
function renderBody(h) {
  return h(
    'div',
    {
      class: `${Services.notifications}-dialog__body`
    },
    [
      renderTags.call(this, h),
      renderId.call(this, h),
      renderText.call(this, h),
      renderDetails.call(this, h)
    ]
  )
}

function renderFooter(h) {
  return h(
    'div',
    {
      class: `${Services.notifications}-dialog__footer`,
      slot: 'footer'
    },
    [
      h(
        button,
        {
          props: {
            label: this.getTranslate('misc.buttons.close'),
            mode: buttonModes.flat
          },
          on: {
            click: () => {
              this.proxy = false
            }
          }
        }
      )
    ]
  )
}

export default function(h) {
  let maxWidth
  if (this.viewport.breakpoint.mdUp) {
    maxWidth = 600
  }

  return h(
    components.dialog,
    {
      props: {
        title: this.getTranslate(`${Services.notifications}.types.${this.data.type}`),
        value: this.proxy,
        maxWidth
      },
      on: {
        input: event => {
          this.proxy = event
        }
      }
    },
    [
      renderBody.call(this, h),
      renderFooter.call(this, h)
    ]
  )
}
